// extracted by mini-css-extract-plugin
export default {"productDescription":"q_-z","featuredDescription":"r_-z","description":"s_-z","more":"t_-z","descriptionSku":"u_-z"};